<template>
    <div id="app">
        <!--    <auth v-if="!user.auth || !userStore.user.id" v-on:auth_success="set_auth"></auth>-->
        <auth v-if="!userStore.user.id" v-on:auth_success="set_auth" v-on:openModal="openModal"></auth>

        <div v-else class="flex_wrapper">
            <div class="sidebar">
                <navigation :page="page" :config="config" v-if="page.data_is_fill"></navigation>
            </div>
            <div class="content">
                <router-view :page="page" name="head"></router-view>
                <router-view
                    v-on:setPagesVars="setPagesVars"
                    v-on:openModal="openProductModal"
                    v-on:openModalPromo="openModalPromo"
                    v-on:openModalNews="openModalNews"
                    v-on:openModalFb="openModal"
                    v-on:logout="logout"
                    :config="config" name="morph">
                </router-view>
                <basement v-if="page.data_is_fill"></basement>
            </div>
        </div>

        <notifications></notifications>

        <modal name="Product_modal"
               :width="1200"
               :height="2500"
               :adaptive="true">
            <modalProduct></modalProduct>
        </modal>

        <modal name="modal" :height="500" :adaptive="true">
            <fb></fb>
        </modal>

        <modal name="modal_promo" :width="1200" :height="2500" :adaptive="true">
            <div class="promo_m_wrap" v-if="dicStore.promo.modal.properties && Object.keys(dicStore.promo.modal.properties).length">
                <div class="b_close" @click="$modal.hide('modal_promo')">
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                        <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                    </svg>
                </div>
                <div class="scan_title">{{ dicStore.promo.modal.properties.title.value }}</div>
                <div class="content_wrap" v-html="dicStore.promo.modal.properties.content.value"></div>
                <div class="suffix">По всем интересующим Вас вопросам свяжитесь с Вашим менеджером!</div>
            </div>
        </modal>


        <modal name="modal_news" class="modal_news_edits" :width="1100" :height="2500" :adaptive="true">
            <div class="promo_m_wrap" v-if="dicStore.b2b_news.modal.properties && Object.keys(dicStore.b2b_news.modal.properties).length">

                <div
                    class="modal_header_wrapper"
                >
                    <div class="modal_header_title">{{ dicStore.b2b_news.modal.properties.zagolovok_1.value }}</div>
                    <div class="modal_header_close" @click="$modal.hide('modal_news')">
                    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                        <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                    </svg>
                </div>
                </div>

                <div class="content_wrap">

                    <div class="thumb">
                        <img v-if="dicStore.b2b_news.modal.properties.izobrazenie.value" v-bind="{ src: '/storage/'+dicStore.b2b_news.modal.properties.izobrazenie.value }">
                    </div>

                    <div class="" v-html="dicStore.b2b_news.modal.properties.polnoe_opisanie.value">

                    </div>

                    <div class="date" v-if="dicStore.b2b_news.modal.properties.data_stroka.value">{{ dicStore.b2b_news.modal.properties.data_stroka.value }}</div>

                </div>


            </div>
        </modal>



    </div>
</template>

<script>
import Auth from "@/components/auth";
import modalProduct from "@/components/modalProduct";
import fb from "@/components/fb";
import navigation from "@/components/navigation";
import basement from "@/components/basement";
import {useUserStore} from '@/stores/UserStore'
import {useDicStore} from '@/stores/DicStore'
import {useProductsStore} from '@/stores/ProductsStore'
import {useOthStore} from '@/stores/OthStore'
import debounce from 'lodash/debounce';




export default {
    name: 'App',
    components: {
        Auth,
        modalProduct,
        fb,
        navigation,
        basement,
    },
    setup() {
        const userStore = useUserStore()



        const dicStore = useDicStore()
        const ProductsStore = useProductsStore()
        //userStore.fill();
        return {
            userStore,
            dicStore,
            ProductsStore,
        }
    },
    data: function () {
        return {
            config: {
                relative_path: '/panel/',
            },
            user: {
                login: "",
                auth: false,
            },
            page: {
                title: 'Заголовок',
                ui: {
                    show_menu: false,
                    fixed_menu: false,
                },
                data_is_fill: false
            }
        }
    },
    methods: {
        openProductModal() {
            this.showModalProduct();
        },
        showModalProduct() {
            this.$modal.show('Product_modal');
        },
        hideModalProduct() {
            this.$modal.hide('Product_modal');
        },
        openModal() {
            this.$modal.show('modal');
        },


        openModalPromo() {
            this.$modal.show('modal_promo');
        },
        openModalNews() {
            this.$modal.show('modal_news');
        },
        logout() {
            console.log('Выходим');
            //this.user.auth = false;
            this.userStore.send_logout();
            //this.userStore.user.id = false;
        },
        setPagesVars(pageVars) {
            if (typeof (pageVars.title) != "undefined" && pageVars.title !== null) {
                this.page.title = pageVars.title;
            }
            if (typeof (pageVars.show_menu) != "undefined" && pageVars.show_menu !== null) {
                this.page.ui.show_menu = pageVars.show_menu;
            }
        },
        set_auth() {
            console.log('set_auth');
            this.user.auth = true;
            this.fillData();
        },
        async fillData() {
            let promise = new Promise((resolve) => {

                Promise.all([
                    this.userStore.fill(),
                    this.dicStore.fill(),
                    this.dicStore.fill_vershina_links(),
                    this.dicStore.fill_b2b_news(),
                    this.dicStore.fill_ui_el(),
//                    this.ProductsStore.fill_search_cat(),
                    this.ProductsStore.fill_search_params(),
                    //this.OthStore.fill_search_cat(),
                    //this.userStore.update_oth_basket();
                ]).then(() => {
                    this.try_show_info();
                    resolve("loading");
                });
            });
            let result = await promise;
            this.checkFillData(result); // TODO: это нужно выполнить по завершению всех обращений к API
        },

        try_show_info() {
            if (this.userStore.session === true) {
                this.$modal.show('info_modal')
            }
        },
        checkFillData() {
            if (Object.keys(this.dicStore.ui_el).length > 0) {
                this.page.data_is_fill = true;
            }
        },
        response_process(reqResult) {
            if (typeof (reqResult.type !== "undefined") && reqResult.type === 'success') {
                this.$notifySuccess(reqResult.message);
            } else if (typeof (reqResult.type !== "undefined") && reqResult.type === 'info') {
                this.$notifyInfo(reqResult.message);
            } else {
                this.$notifyError(reqResult.message);
            }
        },
        handleScroll() {
            // Any code to be executed when the window is scrolled
            this.isUserScrolling = (window.scrollY > 0);
            //console.log('Скролл до: ',window.scrollY);
            /* if (window.scrollY > 970) {
                //пока отключаем эту возможность
                this.page.ui.fixed_menu = false;
            } else {
                this.page.ui.fixed_menu = false;
            } */
        },



    },
    mounted() {
        //this.checkLogin();
        this.fillData();
        //console.log(this.fillData());
        //this.checkFillData();
        this.handleDebouncedScroll = debounce(this.handleScroll, 100);
        window.addEventListener('scroll', this.handleDebouncedScroll);
    },
    beforeDestroy() {
        // I switched the example from `destroyed` to `beforeDestroy`
        // to exercise your mind a bit. This lifecycle method works too.
        window.removeEventListener('scroll', this.handleDebouncedScroll);
    },
    created() {
        //this.$route.params.page = this.page;
        //this.checkLogin();
    }
}
</script>

<style>
.overflow_lock {
    overflow-y: hidden;
}
.modal_header_wrapper {
    display: flex;
    width: 100%;
    gap: 20px;
    padding: 30px 20px;
    align-items: center;
    box-sizing: border-box;
}

@media only screen and (max-width: 900px) {
    .thumb img{
        max-width: 100%;
        height: auto;
    }

}
.modal_header_close {
    display: flex;
    width: 30px;
    height: 30px;
    cursor: pointer;
    flex-shrink: 0;
}
.modal_header_close > svg {
    fill: #174A8B;
    width: 30px;
    height: 30px;
}
.modal_header_title {
    display: flex;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    color: #174A8B;
}
.modal_news_edits {
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal_news_edits > div.vm--modal {
    overflow-y: scroll;
    height: 800px !important;
    left: 0 !important;
}
.info_modal_wrap {
    margin: 20px;
}

.info_modal_wrap .info_title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #174A8B;
    margin: 20px 0 20px 0;
}

.info_modal_wrap p {
    padding-bottom: 10px;
    font-size: 18px;
}

.suffix {
    margin: 20px 5% 50px 5%;
    font-size: 24px;
    line-height: 36px;
    font-weight: 600;
    color: #000;
}

.content_wrap {
    margin: 20px 5% 20px 5%;
}

.content_wrap p {
    margin: 0 0 10px 0;
    font-size: 18px;
}

.scan_wrap {
    margin: 50px 5% 10px 5%;
}

.scan_title {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #174A8B;
    margin: 20px 0 20px 0;
}

#app {
    min-height: 100%;
    font-family: 'DIN Pro';
    font-style: normal;
    height: 100%;
}

.flex_wrapper {
    min-height: 100%;
    margin: 0px;
    box-sizing: border-box;
    display: flex;
}

.sidebar {
    height: 100%;
    background-color: #174A8B;
    width: 224px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    position: fixed;
}

.content {
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    margin-left: 224px;
    max-width: 1920px;
}

@media only screen and (max-width: 1200px) {
    .flex_wrapper {
        flex-direction: column;
    }

    .sidebar, .content {
        width: 100%;
    }

    .sidebar {
        position: absolute;
        height: auto;
        z-index: 800;
    }

    .content {
        padding-top: 75px;
        z-index: 200;
        margin-left: auto;

    }
}

.colums_by_half {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.colums_by_half .column {
    display: flex;
    flex-direction: row;
    margin: 35px 0 35px 0;
}

.colums_by_half .column:nth-child(odd) {
    width: 48%;
    margin-right: 2%;
}

.colums_by_half .column:nth-child(even) {
    width: 48%;
    margin-left: 2%;
}

@media only screen and (max-width: 1200px) {
    .colums_by_half .column:nth-child(odd), .colums_by_half .column:nth-child(even) {
        width: 100%;
        margin-right: 0px;
        margin-left: 0px;
    }
}

.blue_border {
    border: solid 3px #174A8B;
    position: relative;
    padding: 35px 25px 0px 25px;
}

.blue_border .title {
    font-size: 30px;
    font-weight: bold;
    color: #174A8B;
    background-color: #FFF;
    position: absolute;
    top: -22px;
    left: 30px;
    padding: 6px 10px 6px 10px;
}

.grey_border {
    border: solid 1px #BEBEBE;
    position: relative;
    padding: 25px;
    font-size: 18px;
}

.grey_border .title {
    font-size: 18px;
    font-weight: bold;
    color: #1A3751;
    background-color: #FFF;
    position: absolute;
    top: -19px;
    left: 31px;
    padding: 7px 8px 9px 8px;
}

.grey_border .important_red::after {
    content: '';
    background-image: url('/panel/images/important_red.svg');
    background-size: 48px 48px;
    height: 48px;
    width: 48px;
    display: inline-flex;
    position: absolute;
    top: -5px;
    left: -55px;
}

.scan_result {
    display: flex;
    justify-content: center;
    margin: 10px
}

.scaner_img {
    width: 282px;
    height: 212px;
    background-image: url('/panel/images/scaner.jpg');
}

.grey_border .success::after {
    content: '';
    background-image: url('/panel/images/important_blue.svg');
    background-size: 48px 48px;
    height: 48px;
    width: 48px;
    display: inline-flex;
    position: absolute;
    top: -5px;
    left: -55px;
}

.grey_border .qestion::after {
    content: '';
    background-image: url('/panel/images/important_blue.svg');
    background-size: 48px 48px;
    height: 48px;
    width: 48px;
    display: inline-flex;
    position: absolute;
    top: -5px;
    left: -55px;
}

.grey_border .important_blue::after {
    content: '';
    background-image: url('/panel/images/important_blue.svg');
    background-size: 48px 48px;
    height: 48px;
    width: 48px;
    display: inline-flex;
    position: absolute;
    top: -5px;
    left: -55px;
}

.grey_border ul {
    color: #589FF9;
    padding: 0 0 0 15px;
}

.grey_border ul li {
    list-style: square;
    list-style-position: outside;
    line-height: 30px;
}

.grey_border a {
    color: #589FF9;
    text-decoration: underline;
}

.grey_border a:hover {
    color: #1A3751;
    text-decoration: none;
}

.grey_border .inner {
    font-size: 16px;
    line-height: normal;
    color: #1A3751;
    width: 100%;
}

.grey_border .case p {
    margin: 0 0 16px 0;
}

.grey_border .case strong {
    font-weight: bold;
}

.grey_border .case a {
    text-decoration: underline;
    color: #174A8B;
    cursor: pointer;
}

.grey_border .case a:hover {
    text-decoration: none;
}

@media only screen and (max-width: 1200px) {
    .blue_border .title {
        font-size: 22px;
    }
}

.head {
    padding: 0 75px 0 80px;
}

.breadcrumbs {
    font-size: 16px;
    padding: 35px 0 0 0;
    color: #ADADAD;
}

.breadcrumbs a {
    color: #009ED5;
    text-decoration: none;
}

.breadcrumbs a:hover {
    color: #009ED5;
    text-decoration: underline;
}

.morph {
    flex-grow: 1;
    padding: 0 75px 0 80px;
}

.panel_title {
    color: #174A8B;
    font-size: 40px;
    font-weight: bold;
    padding: 38px 0 27px 0;
    border-bottom: solid 3px #174A8B;
}

/* search page css */
.search_tabs {
    display: flex;
    flex-direction: row;
    /*justify-content: space-around;*/
    justify-content: left;
    margin-bottom: 40px;
    /*flex-wrap: wrap;*/
    flex-wrap: nowrap;
    align-items: flex-start;
    margin: 0 2.5% 0 2.5%;
}

.search_tabs .tab {
    width: 10%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    justify-content: center;
}

.search_tabs .tab_hide {
    display: none;
}

.search_tabs .tab .ico {
    width: 100%;
    max-width: 120px;
    height: auto;
    margin: 0 auto 0 auto;
    border: solid 3px;
    border-top: 0px;
    display: flex;
    justify-content: center;
}

.search_tabs .tab_default .ico {
    border-color: #FFF;
}

.search_tabs .tab_default:hover .ico {
    border-color: #009ED5;
}

.search_tabs .tab_active .ico {
    border-color: #174A8B;
}

.search_tabs .ico img {
    width: 100%;
    max-width: 90px;
    height: auto;
    max-height: 90px;
    margin: 10px auto 10px auto;
    filter: invert(21%) sepia(65%) saturate(1196%) hue-rotate(187deg) brightness(100%) contrast(98%);

}

.search_tabs .tab_default .ico svg {
    fill: #666;
}

.search_tabs .tab_default:hover .ico svg {
    fill: #009ED5;
}

.search_tabs .tab_active .ico svg {
    fill: #174A8B;
}

.search_tabs .title {
    text-align: center;
    font-size: 16px;
    color: #666;
    margin: 13px 0 0 0;
    overflow: hidden;
    min-height: 35px;
}

.search_tabs .tab:hover .title {
    color: #009ED5;
}

.search_tabs .tab_active .title {
    color: #174A8B;
}

.search_panel {
    margin: 40px 0 20px 0;
}

@media only screen and (max-width: 1200px) {
    /*.search_tabs {*/
    /*  flex-wrap: nowrap;*/
    /*  align-items: start;*/
    /*  margin: 0 2.5% 0 2.5%;*/
    /*}*/
    /*.search_tabs .tab {*/
    /*  width: 10%;*/
    /*}*/
    /*.search_tabs .tab .ico {*/
    /*  width: 100%;*/
    /*  height: auto;*/
    /*}*/
    .search_tabs .tab .ico svg {
        width: 100%;
        height: auto;
        margin: 0px auto 0 0px;
    }

    .search_tabs .title {
        font-size: 14px;
        overflow: hidden;
    }
}

@media only screen and (max-width: 768px) {
    .search_tabs {
        flex-direction: column;
        flex-wrap: wrap;
        margin: 0px;
    }

    .search_tabs .tab {
        width: 100%;
        border: 3px #FFF solid;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .search_tabs .tab_default:hover {
        border-color: #009ED5;
    }

    .search_tabs .tab_active {
        border-color: #174A8B;
    }

    .search_tabs .tab .ico {
        width: 20%;
        border: none;
    }

    .search_tabs .title {
        text-align: left;
        vertical-align: center;
        width: 80%;
        font-size: 24px;
        margin: 0 0 0 0;
    }
}

.form_row {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    /* TODO: убрать  margin-bottom: 30px;*/
}

.form_space {
    justify-content: space-between;
}

.sizes_w .s_wrap {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 35px;
}

.sizes_w {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 20px 0px 0;
}


.sizes_w .select_wrap {
    width: 98px;
}

.add_wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 0 0px 0px 0;
}

.add_wrap .s_wrap {
    margin-bottom: 35px;
}

.add_wrap .select_wrap {
    width: 120px;
    margin-right: 18px;
}

.add_wrap .ostatok_w {
    margin-right: 0px;
    width: 160px;
}

.add_wrap .brand_w {
    width: 170px;
}

.form_row  .big{
    width: 180px;
}

.form_row  .bigest{
    width: 380px;
}

.add_search{
    margin-left: auto;
    display: flex;
    flex-direction: row;
    align-content: center;
    flex-wrap: nowrap;
    justify-content: center;
}

.add_search .text{
    line-height: 30px;
    font-size: 16px;
}
.add_search .s_wrap{
    padding: 0 20px;
    width: 230px;
}

.add_wrap .ply_rate_w {
    width: 170px;
}




.add_wrap .type_w {
    width: 165px;
}

.add_wrap .sezon_w {
    width: 155px;
}

/* TODO: для таких полей понадобиться изменение размера и шрифта при адаптиве */
.add_wrap .select_w300 {
    width: 360px;
}

.add_wrap .select_w140 {
    width: 140px;
}

.add_wrap .select_w180 {
    width: 180px;
}

.add_wrap .select_w240 {
    width: 240px;
}

.sizes_delim {
    width: 10px;
    font-size: 25px;
    color: #174A8B;
    text-align: center;
    line-height: 33px;
    margin-left: 20px;
}

.select_wrap, .input_wrap, .text_wrap {
    position: relative;
}

.input_wrap {
    margin-right: 18px;
}

.select_label, .input_label, .storages_label, .row_w_label .label {
    display: block;
    font-size: 13px;
    color: #ADADAD;
    background-color: #FFF;
    padding: 2px 5px 2px 5px;
    position: absolute;
    top: -10px;
    left: 9px;
}

.input_gray {
    border: solid 1px #ADADAD;
    font-size: 15px;
    color: #174A8B;
    line-height: 22px;
    padding: 5px 5px 5px 5px;
}

.textarea_gray {
    border: solid 1px #ADADAD;
    font-size: 15px;
    color: #174A8B;
    line-height: 22px;
    padding: 5px 5px 5px 5px;
}

.input_title {
    width: 396px;
    margin: 0 0px 0px 0;
}

.input_articul {
    width: 265px;
    margin: 0 0px 0px 0;
}

.input_mincount {
    width: 180px;
    margin: 0 0px 0px 0;
}

.storages {
    position: relative;
    border: solid 1px #ADADAD;
    padding: 13px 15px 11px 15px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
}

.storage {
    display: flex;
    flex-direction: row;
    border: solid 1px #FFF;
    margin: 0 20px 0 0;
    cursor: pointer;
}

@media only screen and (max-width: 1200px) {
    .storages {
        flex-wrap: wrap;
        margin-bottom: 20px
    }

    .storage {
        margin-top: 10px;
    }
}

.storage:hover {
    border-color: #009ED5;
}

.storages .active {
    border-color: #174A8B;
    background-color: #40769E;
    cursor: pointer;
}

.storage .ico {
    width: 25px;
    height: 25px;
    margin: 2px 6px 2px 6px;
}

.ico_plus svg {
    width: 17px;
    height: 17px;
    margin: 4px 0 0 4px;
}

.ico_geo svg {
    width: 18px;
    height: 18px;
    margin: 3px 0 0 2px;
}

.ico_delivery svg {
    width: 25px;
    height: 13px;
    margin: 6px 0 0 0px;
}

.storage .ico svg {
    fill: #174A8B;
}

.storage:hover .ico svg {
    fill: #009ED5;
}

.storages .active .ico svg {
    fill: #FFF;
}

.storage .name {
    font-size: 15px;
    color: #174A8B;
    line-height: 25px;
    margin: 2px 9px 0px 0;
}

.storage:hover .name {
    color: #009ED5;
}

.storages .active .name {
    color: #FFF;
}

.buttons {
    display: flex;
}

.search_panel .buttons {
    margin-bottom: 35px
}

.buttons input, .send_button {
    display: block;
    text-align: center;
    width: 150px;
    height: 55px;
    font-size: 17px;
    line-height: 55px;
    color: #FFF;
    border: none;
    cursor: pointer;
    font-family: 'DIN Pro';
    -webkit-box-shadow: 4px 4px 0px 0px rgba(154, 188, 214, 1);
    -moz-box-shadow: 4px 4px 0px 0px rgba(154, 188, 214, 1);
    box-shadow: 4px 4px 0px 0px rgba(154, 188, 214, 1);
    margin: 0 24px 0 0;
}

.buttons input:hover, .send_button:hover {
    -webkit-box-shadow: 2px 2px 0px 0px rgba(154, 188, 214, 1);
    -moz-box-shadow: 2px 2px 0px 0px rgba(154, 188, 214, 1);
    box-shadow: 2px 2px 0px 0px rgba(154, 188, 214, 1);
    background-color: #A1C084;
    color: #174A8B;
}

.buttons .clear {
    background-color: #69A2B0;
}

.buttons .extended {
    background-color: #40769E;
    width: 185px;
}

.buttons .send, .send_button {
    background-color: #174A8B;
    font-weight: 900;
}

.buttons_small .send{
    font-weight: 400;
    height: 30px;
    line-height: 30px;
    width: 120px;
}

.view_select {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 30px 0 0 0;
}

.view_select .icons {
    display: flex;
    flex-direction: row;
    margin: 0 10px 0 0;
}

.view_select .ico {
    width: 18px;
    height: 18px;
    margin: 2px 3px 0 3px;
    cursor: pointer;
}

.view_select .ico svg {
    width: 18px;
    height: 18px;
    stroke: #ADADAD;
}

.view_select .ico:hover svg {
    stroke: #009ED5;
}

.view_select .active svg {
    stroke: #174A8B;
}

.view_select .title {
    font-size: 16px;
    color: #174A8B;
    line-height: 20px;
}

.search_results {
    margin: 36px 0 80px 0;
}

.table .img_wrap, .cells .img_wrap {
    cursor: pointer;
}

.table {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

.table .c_wrap {
    width: 100%;
    height: auto;
    position: relative;
    border-bottom: dashed #CCC 1px;
}

.table .t_head {
    border-bottom: 5px solid #174a8b;
}

/*.table .t_head .sel_wrap,.table .t_head .articul,.table .t_head .title,.table .t_head .icons {*/
/*  height: 40px;*/
/*  padding: 3px 0 3px 0;*/
/*}*/
.table .t_head .cell .icons {
    height: auto;
}

.table .t_sort_wrap {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    height: 40px;
    padding: 3px 0 3px 0;
}

.table .t_sort_wrap:hover {
    background-color: #589FF9;
}

.table .txt {
    font-weight: 600;
    font-size: 14px;
    color: #000;
}

.table .arrow {
    width: 11px;
    height: 18px;
}

.table .arrow svg {
    width: 11px;
    height: 11px;
    cursor: pointer;
}

.table .no_act svg {
    fill: #333;
}

.table .act svg {
    fill: #174A8B;
}

.table .rotate svg {
    transform: rotate(180deg)
}

.table .cell {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /*justify-content: start;*/
    align-items: center;
    flex-wrap: nowrap;
    background-color: #FFF;
    position: relative;
    z-index: 100;
    margin: 6px 0 6px 0;
}

.table .cell .img_wrap {
    width: 50px;
    height: auto;
    flex-shrink: 0;
    margin: 0 40px 0 0;
}

.table .cell .img_wrap img {
    width: 100%;
    height: auto;
    max-height: 100px;
    max-width: 50px;
    margin: 0px;
}

.table .cell .title {
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
    color: #000;
    display: block;
    text-align: center;
    margin: 0 auto 0 0px;
    overflow: hidden;
    text-decoration: none;
    text-align: left;
}

.table .cell .price {
    display: none;
}

.table .cell .sel_wrap {
    width: 15px;
    height: 15px;
}

.table .sel_wrap input {
    margin: 0px;
    padding: 0px;
    width: 15px;
    height: 15px;
}

.table .cell .articul {
    font-size: 14px;
    color: #000;
}

.table .cell .icons {
    width: 25px;
    height: 20px;
    line-height: 30px;
    display: flex;
    flex-direction: row-reverse;
}

.table .cell .ico {
    width: 25px;
    height: 20px;
    margin: 0 0 0 0;
}

.table .expand_stores {
    display: none;
}

.table .store {
    width: 490px;
    margin-left: auto;
    flex-direction: row;
    margin: 0px 0 0 20px;
    padding: 3px 0 3px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 2px dotted #adadad;
}

.table .store:nth-child(1) {
    border-top: none;
}

.table .t_head .store {
    border-top: none;
}

.table .store .row1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 40px;
    align-items: center;
}

.table .store .loc {
    font-size: 16px;
    font-weight: 200;
    color: #666;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.table .higth .loc {
    color: #174A8B;
}

.table .loc {
    width: 120px;
}

.table .store .loc .ico_store {
    display: flex;
    width: 35px;
    justify-content: center;
}

.table .store .loc .ico_store svg {
    margin: 0 auto 0 auto;
}

.table .store .loc svg {
    fill: #666;
}

.table .higth .loc svg {
    fill: #174A8B;
}

.table .store .ico_geo {
    width: 18px;
    height: 19px;
}

.table .store .ico_geo svg {
    width: 18px;
    height: 19px;
    margin: 0px 0 0 0px;
}

.table .store .ico_delivery {
    width: 30px;
    height: 14px;
}

.table .store .ico_delivery svg {
    width: 30px;
    height: 14px;
}

.table .store .loc .name {
    margin: 0px 0 0 0px;
}

.table .store .digits {
    font-size: 14px;
    color: #000;
    width: 55px;
}

.table .store .left {
    margin: 0px 0 0 0;
    font-size: 14px;
    color: #666;
    width: 50px;
}

.table .higth .left {
    color: #174A8B;
}

.table .store .row2 {
    display: flex;
    flex-direction: row;
    /*width: 135px;*/
    width: 170px;
    justify-content: space-between;
    margin: 0 0 0 0;
}

.table .store .stock {
    display: none;
}

.table .row3 {
    display: none;
}

.table .add_ui {
    width: 133px;
    height: 38px;
    border: solid 1px #ADADAD;
    display: flex;
    flex-direction: row;
}

.table .t_head .add_ui {
    border-color: #fff;
    line-height: 40px;
}

.table .add_ui .added {
    font-size: 24px;
    font-weight: bold;
    color: #174A8B;
    width: 40px;
    line-height: 28px;
    color: #659157;
    margin: 4px 0 0 0;
    text-align: center;
}

.table .add_ui .button {
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #ADADAD;
    text-align: center;
    border: solid 1px #FFF;
    cursor: pointer;
    margin: 5px 2px 0px 2px;
}

.table .add_ui .active, .add_ui .button:hover {
    border: solid 1px #ADADAD;
    color: #174A8B;
}

.table .store_price {
    font-size: 27px;
    color: #000;
    line-height: 33px;
    margin: 0 6px 0 0;
}

.table .store_price {
    display: none;
}

.table .articul {
    width: 150px;
    margin-right: 10px;
    margin-left: 10px;
    flex-shrink: 0;
}

.table .store .row1 {
    width: 340px;
    margin-right: auto;
}

@media only screen and (max-width: 1600px) {
    .table .articul {
        width: 100px;
        font-size: 12px;
    }

    .table .cell .img_wrap {
        margin-right: 10px;
    }
}

/*@media only screen and (max-width: 768px) {*/
@media only screen and (max-width: 1200px) {
    .table .t_head {
        display: none
    }

    .table .cell {
        flex-wrap: nowrap;
    }

    .table .s_hide .cell {
        flex-direction: row;
    }

    .table .s_expand .cell {
        flex-direction: column;
        flex-wrap: wrap;
        justify-content: center;
    }

    .table .cell .sel_wrap {
        display: none
    }

    .table .cell .articul {
        width: auto;
        text-align: center;
        margin-left: 5px;
        margin-right: 0;
    }

    .table .s_hide .articul {
        display: none;
    }

    .table .s_expand .articul {
        display: block;
        margin: 10px 0 10px 0
    }

    .table .cell .title {
        width: auto;
        flex-shrink: 1;
        margin-left: 0;
    }

    .table .s_expand .cell .title {
        width: 100%;
        text-align: center;
        margin: 10px 0 10px 0
    }

    .table .s_hide .img_wrap {
        display: none
    }

    .table .s_expand .img_wrap {
    }

    .table .s_hide .icons {
        display: none;
    }

    .table .s_expand .icons {
        display: flex;
    }

    .table .cell .price {
        flex-shrink: 0;
        width: 70px;
        margin: 0 5px 0 auto;
        display: block;
        font-size: 22px
    }

    .table .s_expand .price {
        display: none
    }

    .table .cell .stores_wrap {
    }

    .table .s_hide .stores_wrap {
        display: none
    }

    .table .s_expand .stores_wrap {
        width: 100%;
        display: flex;
        flex-direction: column
    }

    .table .store {
        width: 100%;
        margin-left: 0;
        flex-wrap: wrap;
    }

    .table .store .row1 {
        width: 260px
    }

    .table .loc {
        width: 120px
    }

    /*.table .store .loc .ico_store { display: none}*/
    .table .store .row2 {
        margin-right: 5px;
    }

    .table .expand_stores {
        display: block;
        cursor: pointer;
        text-align: center;
        font-size: 14px;
        text-transform: uppercase;
        text-decoration: underline;
        flex-shrink: 0;
    }

    .table .expand_stores:hover {
        text-decoration: none;
    }

    .table .expd_default {
        width: 80px;
        color: #174A8B;
    }

    .table .expd_hide {
        width: 100%;
        line-height: 36px;
        color: #000000;
        background-color: #ADADAD;
        order: 999;
    }
}

@media only screen and (max-width: 480px) {
    .table .s_hide .title {
        margin-right: 5px;
    }

    .table .s_hide .price {
        font-size: 18px;
        width: 60px;
    }

    .table .expand_stores {
        font-size: 11px
    }

    .table .expd_default {
        width: 50px;
    }

    .table .store .row1 {
        width: 200px;
        margin: 0 auto 0 auto;
    }

    .table .store .loc {
        width: 60px;
    }

    .table .store .loc .ico_store {
        display: none
    }

    .table .store .loc .name {
        font-size: 12px;
    }

    .table .store .row2 {
        margin: 0 auto 5px auto;
    }
}

.cells {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}

.cells .c_wrap {
    width: 242px;
    /*height: 390px;*/
    height: 438px;
    margin: 6px;
    position: relative;
}

.cells .t_head {
    display: none;
}

.cells .cell {
    width: 240px;
    min-height: 386px;
    height: auto;
    border: dashed #000000 1px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    background-color: #FFF;
    position: relative;
    z-index: 100;
}

/*.cells .cell:hover,.s_expand .cell {*/
.s_expand .cell {
    z-index: 200;
    -webkit-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.25);
}

.cells .cell .sel_wrap {
    width: 15px;
    height: 15px;
    position: absolute;
    top: 10px;
    left: 10px;
}

.cells .sel_wrap input {
    margin: 0px;
    padding: 0px;
    width: 15px;
    height: 15px;
}

.cells .cell .articul {
    font-size: 14px;
    color: #000;
    position: absolute;
    top: 10px;
    left: 30px;
    width: 150px;
}

.cells .cell .img_wrap {
    /*width: 240px;*/
    /*height: 240px;    */
    /*margin: 15px auto 9px auto;*/
    width: 200px;
    height: 200px;
    margin: 45px auto 19px auto;
    align-content: center;
    text-align: center;
}

.cells .cell .img_wrap img {
    height: auto;
    max-height: 200px;
    width: auto;
    max-width: 200px;
    margin: 0 auto 0 auto;
}

.cells .cell .title {
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
    color: #000;
    display: block;
    text-align: center;
    margin: 9px 5px 0 5px;
    height: 62px;
    overflow: hidden;
    text-decoration: none;
}

.cells .cell .price {
    font-size: 19px;
    color: #174A8B;
    margin: 0 auto 7px auto;
    text-align: center;
}

.cells .cell .icons {
    position: absolute;
    right: 8px;
    top: 5px;
    width: 90px;
    height: 30px;
    display: flex;
    flex-direction: row-reverse;
}

.cells .cell .ico {
    width: 30px;
    height: 30px;
    margin: 0 0 0 0;
}

.cells .expand_stores {
    width: 100%;
    text-align: center;
    font-size: 14px;
    line-height: 45px;
    text-decoration: underline;
    text-transform: uppercase;
    font-weight: bold;
    color: #174A8B;
    cursor: pointer;
}

.cells .expd_default:hover {
    text-decoration: none;
    color: #FFF;
    background-color: #174A8B;
}

.cells .expd_hide {
    color: #000000;
    background-color: #ADADAD;
}

.cells .expd_hide:hover {
    text-decoration: none;
    color: #000000;
    background-color: #ADADAD;
}

.cells .stores_wrap {
    display: none;
    flex-direction: column;
}

/*.cells .cell:hover .stores_wrap {*/
/*  display: flex;*/
/*}*/
.cells .s_expand .stores_wrap {
    display: flex;
    flex-direction: column;
}

.cells .store {
    border-top: dashed #ADADAD 1px;
    flex-direction: column;
    margin: 0 10px 12px 10px;
}

.cells .store .row1 {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
}

.cells .store .loc {
    font-size: 16px;
    font-weight: 200;
    color: #666;
    display: flex;
    flex-direction: row;
}

.cells .higth .loc {
    color: #174A8B;
}

.cells .store .loc .ico_store {
    width: 30px;
    height: 25px;
    margin: 13px 0 0 0;
}

.cells .store .loc svg {
    fill: #666;
}

.cells .higth .loc svg {
    fill: #174A8B;
}

.cells .store .ico_geo svg {
    width: 18px;
    height: 19px;
    margin: 2px 0 0 7px;
}

.cells .store .ico_delivery svg {
    width: 30px;
    height: 14px;
    margin: 2px 0 0 0px;
}

.cells .store .loc .name {
    margin: 15px 0 0 7px;
}

.cells .store .vip {
    text-align: right;
    font-size: 27px;
    line-height: 38px;
    width: 107px;
}

.cells .store .left {
    display: none;
    margin: 18px 6px 0 0;
    font-size: 14px;
    color: #666;
}

.cells .higth .left {
    color: #174A8B;
}

.cells .store .mrc {
    display: none;
}

.cells .store .row2 {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    margin: 10px 0 0 0;
    align-items: center;
}

.cells .store .stock {
    font-size: 18px;
    color: #000;
    overflow: hidden;
}

.cells .store .stock span {
    font-size: 14px;
    color: #ADADAD;
    margin-right: 1px;
}

.cells .row3 {
    padding-top: 5px;
}

.cells .add_ui {
    width: 133px;
    height: 38px;
    border: solid 1px #ADADAD;
    display: flex;
    flex-direction: row;
}

.cells .add_ui .added {
    font-size: 24px;
    font-weight: bold;
    color: #174A8B;
    width: 40px;
    line-height: 28px;
    color: #659157;
    margin: 4px 0 0 0;
    text-align: center;
}

.cells .add_ui .button {
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #ADADAD;
    text-align: center;
    border: solid 1px #FFF;
    cursor: pointer;
    margin: 5px 2px 0px 2px;
}

.cells .add_ui .active, .add_ui .button:hover {
    border: solid 1px #ADADAD;
    color: #174A8B;
}

.cells .store_price {
    display: none;
    font-size: 27px;
    color: #000;
    line-height: 33px;
    margin: 0 6px 0 0;
    width: 70px;
    overflow: hidden;
}

.cells .higth .store_price {
    color: #174A8B;
}

.psevdo_link {
    text-decoration: underline;
    color: #174A8B;
    cursor: pointer;
}

.psevdo_link:hover {
    text-decoration: none;
}

.button_simple {
    display: block;
    width: 100%;
    height: 55px;
    text-align: center;
    font-size: 17px;
    text-transform: uppercase;
    text-decoration: none;
    line-height: 55px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
}

.b_blue {
    background-color: #174A8B;
    color: #FFF;
}

.b_blue .cur svg {
    fill: #174A8B;
}

.b_green {
    background-color: #42b983;
    color: #000;
}

.b_green .cur svg {
    fill: #42b983;
}

.button_simple .cur {
    display: block;
    width: 36px;
    height: 18px;
    position: absolute;
    top: -12px;
    left: 4px;
    /*background-image: url('/panel/images/square_basket.svg');
    background-position: 0 0;*/
}

.order_info {
    margin-top: 20px
}

.order_info .row_w_label {
    margin-bottom: 20px;
}

.row_w_label {
    width: 100%;
    position: relative;
    margin: 10px 0 0 0;
}

.row_w_label .row {
    border: solid 1px #ADADAD;
    font-size: 18px;
    color: #174A8B;
    line-height: 22px;
    padding: 5px 5px 5px 5px;
    min-height: 34px;
}

.count_ui {

}

.count_head {
    font-size: 16px;
    font-weight: 500;
    line-height: 36px;
    border-bottom: solid 3px #174A8B;
}

.count_ui .row {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.count_ui .ligth_font {
    font-size: 14px;
    font-weight: 400;
    line-height: 26px;
}

.count_ui .title {
    width: auto;
    margin-right: auto;
}

.count_ui .sum {
    width: 100px;
}

.count_ui .count {
    width: 150px;
}

.count_ui .price {
    width: 100px;
}

.count_ui .del {
    width: 100px;
    cursor: pointer
}

.count_ui .del svg {
    width: 15px;
    height: 15px;
    fill: #174A8B;
}

.b_total {
    text-align: right;
    font-size: 26px;
    border-top: 1px dashed #dee2e6;
    color: #1a3752;
    margin-bottom: 20px;
    margin-top: 0px;
    padding-top: 15px;
}

.page_ui {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-content: center;
    margin: 20px 0 20px 0;
    flex-wrap: wrap;
    align-items: center;
}

.page_ui .pages {
    width: 180px;
    text-align: center;
}

.page_ui .step_selector {
    margin-right: 10px;
}

.page_ui .step_selector .select_wrap {
    width: 105px;
}

/*.page_ui .s_title {*/
/*  width: 170px;*/
/*  text-align: right;*/
/*  margin-right: 10px;*/
/*}*/

.sort_wrap {
    width: 320px;
    display: flex;
    flex-direction: row;
}

.sort_wrap .select_wrap {
    width: 150px;
    margin-right: 10px
}

.page_ui .pagination2 {
    margin-left: auto;
}

.pagination2 {
    max-width: 500px;
    margin: 0 auto 0 auto
}

.pagination2 nav {

}

.pagination2 nav ul {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #174A8B;
    padding: 5px;
}

.pagination2 nav ul li {
    display: block;
}

.pagination2 nav ul li a {
    display: block;
    background-color: #174A8B;
    color: #FFF;
    text-align: center;
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    border: solid 2px #174A8B;
}

.pagination2 nav ul li a:hover {
    border-color: #FFF;
}

.pagination2 nav ul li a.active {
    border-color: #589FF9;
}

.pagination2 p {
    margin-top: 10px;
    text-align: center;
}

.product_wrap {
    padding: 10px;
}

.product_wrap .item_cart {
    display: flex;
    flex-direction: row;
}

.item_cart .rows_wrap {
    width: 60%;
}

.item_cart .imgs_wrap {
    width: 40%;
    padding: 0 5% 0 5%;
}

.item_cart .imgs_wrap .img {
    width: 100%
}

.item_cart .imgs_wrap .img a img {
    width: 100%;
    height: auto;
}

.b_close {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.b_close svg {
    width: 30px;
    height: 30px;
    fill: #174A8B;
}

@media only screen and (max-width: 1200px) {
    .cells .c_wrap {
        height: auto;
    }

    .cells .stores_wrap {
        display: flex;
    }

    .cells .expand_stores {
        display: none;
    }

    .cells .store {
        display: flex;
        z-index: 200;
    }

    .add_wrap {
        flex-wrap: wrap;
    }

    .add_wrap .s_wrap {
        margin-bottom: 15px;
    }

    .input_title {
        width: 100%;
        max-width: 220px;
    }

    .input_articul {
        width: 100%;
        max-width: 220px;
    }

    .search_panel .buttons {
        margin-bottom: 0px;
    }

    .search_panel .buttons input {
        margin-bottom: 30px;
    }

    .page_ui {
        flex-direction: column;
        justify-content: center;
    }

    .page_ui .pages {
        margin: 20px 0 20px 0
    }

    .page_ui .step_selector {
        margin: 20px 0 20px 0
    }

    .page_ui .pagination2 {
        margin: 10px auto 10px auto
    }

    .pagination2 nav ul {
        flex-direction: column;
    }

    .pagination2 nav ul li {
        width: 100%;
    }

    .pagination2 nav ul li a {
        width: 100%;
        margin: 0 auto 0 auto;
    }
}

@media only screen and (max-width: 768px) {
    .morph, .head {
        padding: 0 20px 0 20px
    }

    .search_panel .buttons {
        flex-direction: column;
        margin-bottom: 0px;
    }

    .footer .colums_by_half .column {
        flex-direction: column;
    }

    .footer .colums_by_half .column ul {
        margin-bottom: 20px;
    }
}











.tooltip {
    display: block !important;
    z-index: 10000;
}

.tooltip .tooltip-inner {
    background: black;
    color: white;
    border-radius: 16px;
    padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
    border-color: black;
    z-index: 1;
}

.tooltip[x-placement^="top"] {
    margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
    margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
    margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}

.tooltip[x-placement^="left"] {
    margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}

.tooltip.popover .popover-inner {
    background: #f9f9f9;
    color: black;
    padding: 24px;
    border-radius: 5px;
    box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
    border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
}
</style>
